import _ from 'lodash';
import { apiSearch, apiFetch, apiRemove } from './utility';

export const search = (p = {}) => {
	const {callback = _.noop} = p;

	return dispatch => {
		apiSearch({
			base : 'notificationJob',
			dispatch,
			callback,
		});
	};
};

export const searchHistory = (p = {}) => {
	const {callback = _.noop} = p;
	const notificationJobId = p.notificationJobId;

	const params = {
		notificationJobIds : [notificationJobId],
	};

	return dispatch => {
		apiSearch({
			method : 'notificationJob.history.search',
			base : 'notificationHistory',
			keyBy : notificationJobId,
			params,
			dispatch,
			callback,
		});
	};
};


export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'notificationJob.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'notificationJob.add',
			listNameToUpdate : 'notificationJobIds',
			params,
			dispatch,
			successMessage : `Notification Job was created successfully. 
				Click continue to return to the notification jobs page`,
			onSuccessRedirectTo : '/notificationJobs',
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'notificationJob.update',
			params,
			dispatch,
			successMessage : `Notification job was updated successfully. 
				Click continue to return to the notification jobs page`,
			onSuccessRedirectTo : '/notificationJobs',
			callback,
		});
	};
};


export const test = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'notificationJob.test',
			params,
			dispatch,
			callback,
		});
	};
};

export const remove = ({notificationJobId, callback = _.noop}) => {
	return dispatch => {
		apiRemove({
			base : 'notificationJob',
			id : notificationJobId,
			dispatch,
			callback,
		});
	};
};
